import moment from 'moment-timezone';
import { createSelector } from 'reselect';

import { sortByOrderNumber, getSorterByField } from './../orderSorters';
import { getOrderIdsWithUnreadMessages } from './../notification/selectors';

const stable = require('stable');

const getOrderList = state => state.ordersComplete.numbers.map(number => state.orders[number]);
const getSorting = state => state.ordersComplete.sorting;
const getFilter = state => state.ordersComplete.filter;

const filterByTime = (filterTime, orderList) => {
    const stamp = moment();
    switch (filterTime) {
        case 'thisMonth': {
            stamp.startOf('month');
            break;
        }
        case 'lastMonth': {
            stamp.startOf('month').subtract(1, 'month');
            break;
        }
        case 'thisYear': {
            stamp.startOf('year');
            break;
        }
        case 'lastYear': {
            stamp.startOf('year');
            return orderList.filter(item => moment(item.pgrader_complete_at).isSameOrBefore(stamp));
        }
        default:
            return orderList;
    }
    return orderList.filter(item => moment(item.pgrader_complete_at).isSameOrAfter(stamp));
};

const filterBySearch = (filterSearch, orderList) => !filterSearch ? orderList : orderList.filter(item => item.number.toLowerCase().indexOf(filterSearch.toLowerCase()) > -1);

export const getOrdersCompleteFilteredSorted = createSelector(
    [getFilter, getSorting, getOrderIdsWithUnreadMessages, getOrderList],
    (filter, sorting, unreadOrderIds, orderList) => {
        let orders;
        if (!!filter.search) {
            orders = filterBySearch(filter.search, orderList);
        } else {
            orders = filterByTime(filter.time, orderList);
        }

        orders = stable(orders, sortByOrderNumber);
        const sorter = getSorterByField(sorting.field, sorting.isAsc, unreadOrderIds);
        return stable(orders, sorter);
    }
);



// WEBPACK FOOTER //
// ./src/store/ordersComplete/selectors.js